import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useHistory, useParams } from "react-router-dom";
import { logout } from "./actions/authentication";

import Loading from "./Loading";

function Logout() {
  const dispatch = useDispatch();
  const history = useHistory();
  const { then = '%2F' } = useParams() || {};
  const to = decodeURIComponent(then);

  const [loggedOut, setLoggedOut] = useState(false);

  useEffect(() => {
    if (!loggedOut) {
      dispatch(logout())
      .then(() => {
        setLoggedOut(true);
        history.push(to);
        // document.location = `${process.env.PUBLIC_URL}${to}`;
      })
      .catch((error) => {
        console.error(error);
      });
    }
  }, [dispatch, history, loggedOut, setLoggedOut, to]);
  if (!loggedOut) {
    return <Loading />;
  }
  return null;
}

export default Logout;
